/*
  hayat-product.js: صفحة المنتج (sections/hayat-main-product.liquid).
  - <hayat-gallery>: معرض شرائح القصة. سحب بالموبايل، أسهم ومصغّرات، وعدّاد.
    لما الزبون يبدّل التشطيب، product-info.js مال Dawn ينشر variantChange، والمعرض يروح لصورة التشطيب.
  - <hayat-sticky-buy>: شريط طلب ثابت بالموبايل. يبين لما زر الشراء يطلع من فوق الشاشة،
    وزره يضغط زر الشراء الأصلي (حتى Releasit يفتح فورم الطلب بنفس التشطيب والباقة).
  - سعر Kaching: إذا بلوك السعر مفعّل عليه "السعر من Kaching"، كل الأسعار [data-live-price] لنفس المنتج
    تاخذ سعر أول باقة بـ Kaching (قطعة وحدة)، والتوفير يُحسب من السعر المشطوب (Compare-at).
*/
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // اشتراك بتبديل التشطيب من pubsub.js مال Dawn (إذا موجود)
  const onVariantChange = (callback) => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return () => {};
    return subscribe(PUB_SUB_EVENTS.variantChange, callback);
  };

  // 35000 → "35,000" (نفس snippets/hayat-money.liquid)
  const formatMoney = (cents) => Math.round(Number(cents) / 100).toLocaleString('en-US');

  if (!customElements.get('hayat-gallery')) {
    customElements.define(
      'hayat-gallery',
      class HayatGallery extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
          this.thumbStrip = this.querySelector('[data-thumbs]');
          this.counter = this.querySelector('[data-counter]');
          this.prevButton = this.querySelector('[data-prev]');
          this.nextButton = this.querySelector('[data-next]');
          if (!this.track || this.slides.length === 0) return;

          this.index = -1;

          // الشريحة اللي أغلبها قدّام الزبون هي المفعّلة (يشتغل بالـ RTL بدون حسابات scrollLeft)
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
              });
            },
            { root: this.track, threshold: 0.6 }
          );
          this.slides.forEach((slide) => this.observer.observe(slide));

          this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.goTo(i)));
          this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
          this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
          this.track.addEventListener('keydown', (event) => this.onKeydown(event));

          this.unsubscribe = onVariantChange(({ data }) => {
            if (data?.sectionId !== this.dataset.section) return;
            const mediaId = data.variant?.featured_media?.id;
            if (mediaId) this.goToMedia(mediaId);
          });

          const start = parseInt(this.dataset.start, 10) || 0;
          this.setActive(start);
          if (start > 0) requestAnimationFrame(() => this.goTo(start, false));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.unsubscribe?.();
        }

        onKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          // بالـ RTL السهم اليسار يروح للصورة الجاية
          const rtl = getComputedStyle(this).direction === 'rtl';
          const forward = event.key === (rtl ? 'ArrowLeft' : 'ArrowRight');
          this.goTo(this.index + (forward ? 1 : -1));
        }

        goToMedia(mediaId) {
          const i = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
          if (i >= 0) this.goTo(i);
        }

        goTo(i, smooth = true) {
          const target = Math.max(0, Math.min(this.slides.length - 1, i));
          const slide = this.slides[target];
          const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
          this.track.scrollBy({ left: delta, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
          this.setActive(target);
        }

        setActive(i) {
          if (i < 0 || i === this.index) return;
          this.index = i;

          this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
          this.thumbs.forEach((thumb, n) => {
            if (n === i) {
              thumb.setAttribute('aria-current', 'true');
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
          if (this.counter) this.counter.textContent = String(i + 1);
          if (this.prevButton) this.prevButton.disabled = i === 0;
          if (this.nextButton) this.nextButton.disabled = i === this.slides.length - 1;
          this.centerThumb(i);
        }

        // المصغّرة المفعّلة تبقى بنص شريط المصغّرات
        centerThumb(i) {
          const thumb = this.thumbs[i];
          if (!thumb || !this.thumbStrip) return;
          const strip = this.thumbStrip.getBoundingClientRect();
          const box = thumb.getBoundingClientRect();
          const delta = box.left + box.width / 2 - (strip.left + strip.width / 2);
          this.thumbStrip.scrollBy({ left: delta, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      }
    );
  }

  /*
    <hayat-review-peek>: ياخذ أول [count] آراء من قسم الآراء بنفس الصفحة ويعرضهن وحدة وحدة،
    يتبدلن كل 5 ثواني (يوقف وقت الـ hover واللمس، وبرا الشاشة، ويا تقليل الحركة)، ونقاط للتنقل.
  */
  if (!customElements.get('hayat-review-peek')) {
    customElements.define(
      'hayat-review-peek',
      class HayatReviewPeek extends HTMLElement {
        connectedCallback() {
          const source = document.querySelector(this.dataset.source || '#reviews');
          const count = parseInt(this.dataset.count, 10) || 3;
          const reviews = source ? Array.from(source.querySelectorAll('.hayat-review')).slice(0, count) : [];
          this.track = this.querySelector('[data-peek-track]');
          this.dotsWrap = this.querySelector('[data-peek-dots]');
          if (reviews.length === 0 || !this.track) return;

          this.slides = reviews.map((review) => this.buildSlide(review));
          this.slides.forEach((slide) => this.track.appendChild(slide));

          if (this.slides.length > 1 && this.dotsWrap) {
            this.dots = this.slides.map((_, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'hayat-peek__dot';
              dot.setAttribute('aria-label', `${i + 1} / ${this.slides.length}`);
              dot.addEventListener('click', () => {
                this.show(i);
                this.restart();
              });
              this.dotsWrap.appendChild(dot);
              return dot;
            });
          }

          this.hidden = false;
          this.index = -1;
          this.show(0);

          this.paused = false;
          ['mouseenter', 'focusin', 'touchstart'].forEach((type) =>
            this.addEventListener(type, () => (this.paused = true), { passive: true })
          );
          ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => (this.paused = false)));

          this.visible = false;
          this.observer = new IntersectionObserver(([entry]) => (this.visible = entry.isIntersecting));
          this.observer.observe(this);
          this.restart();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.observer?.disconnect();
        }

        // نسخة مختصرة من بطاقة الرأي: النجوم، النص، والاسم والمحافظة
        buildSlide(review) {
          const slide = document.createElement('figure');
          slide.className = 'hayat-peek__slide';

          const stars = review.querySelector('.hayat-review__stars');
          if (stars) slide.appendChild(stars.cloneNode(true));

          const text = document.createElement('blockquote');
          text.className = 'hayat-peek__text';
          text.textContent = review.querySelector('.hayat-review__text')?.textContent.trim() || '';
          slide.appendChild(text);

          const name = review.querySelector('.hayat-review__who b')?.textContent.trim() || '';
          const city = review.querySelector('.hayat-review__who small')?.textContent.trim() || '';
          const who = document.createElement('figcaption');
          who.className = 'hayat-peek__who';
          who.textContent = [name, city].filter(Boolean).join('، ');
          slide.appendChild(who);
          return slide;
        }

        show(i) {
          if (i === this.index) return;
          this.index = i;
          this.slides.forEach((slide, n) => {
            slide.classList.toggle('is-active', n === i);
            slide.setAttribute('aria-hidden', String(n !== i));
          });
          this.dots?.forEach((dot, n) => dot.setAttribute('aria-current', String(n === i)));
        }

        restart() {
          clearInterval(this.timer);
          if (reduceMotion.matches || this.slides.length < 2) return;
          this.timer = setInterval(() => {
            if (this.paused || !this.visible || document.hidden) return;
            this.show((this.index + 1) % this.slides.length);
          }, 5000);
        }
      }
    );
  }

  if (!customElements.get('hayat-sticky-buy')) {
    customElements.define(
      'hayat-sticky-buy',
      class HayatStickyBuy extends HTMLElement {
        connectedCallback() {
          const section = this.dataset.section;
          this.productInfo = document.getElementById(`MainProduct-${section}`);
          if (!this.productInfo) return;

          this.buyBox = this.productInfo.querySelector('[data-buy-box]');
          this.buyButtons = this.productInfo.querySelector('.hayat-product__buy') || this.buyBox;
          this.button = this.querySelector('[data-sticky-order]');
          this.price = this.querySelector('[data-sticky-price]');
          this.variantName = this.querySelector('[data-sticky-variant]');
          this.image = this.querySelector('.hayat-sticky-buy__img');
          if (!this.buyButtons) return;

          // يبين بس لما زر الشراء يطلع من فوق الشاشة (الزبون نزل تحته)، مو قبل ما يوصله
          this.observer = new IntersectionObserver(([entry]) => {
            this.toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
          this.observer.observe(this.buyButtons);

          this.button?.addEventListener('click', () => this.order());
          this.unsubscribe = onVariantChange(({ data }) => {
            if (data?.sectionId === section) this.update(data.variant);
          });
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.unsubscribe?.();
          document.documentElement.style.removeProperty('--hayat-sticky-space');
        }

        // زر Releasit العائم (إذا مفعّل من إعدادات التطبيق) يبين تحت الشاشة دائماً، فما نعرض شريطنا فوقه.
        // يرجّع الزر الظاهر أو null
        releasitFloating() {
          // نفحص الزر نفسه مو غلافه (الغلاف ارتفاعه صفر لأن الزر fixed)، وبالحجم لأن offsetParent دائماً null للـ fixed
          return (
            Array.from(document.querySelectorAll('#rsi_buy_now_button.rsi_floating')).find((button) => {
              const rect = button.getBoundingClientRect();
              return getComputedStyle(button).display !== 'none' && rect.width > 0 && rect.height > 0;
            }) || null
          );
        }

        toggle(show) {
          const floating = this.releasitFloating();
          show = show && !floating;
          this.classList.toggle('is-visible', show);
          this.setAttribute('aria-hidden', String(!show));
          this.toggleAttribute('inert', !show);
          // مسافة تحت الفوتر حتى الشريط (شريطنا أو زر Releasit العائم) ما يغطي آخر سطر
          let space = show ? this.offsetHeight : 0;
          if (floating) space = Math.max(0, Math.round(window.innerHeight - floating.getBoundingClientRect().top));
          document.documentElement.style.setProperty('--hayat-sticky-space', `${space}px`);
        }

        // يضغط زر Releasit (إذا موجود) حتى يفتح فورم الطلب بالتشطيب والباقة المختارة،
        // وإلا زر الشراء الأصلي. Releasit يخفي زر الثيم ويحط زره مكانه داخل الـ form
        order() {
          const releasit = this.productInfo.querySelector('#rsi_buy_now_button:not(.rsi_floating)');
          if (releasit && releasit.offsetParent !== null) {
            releasit.click();
            return;
          }
          const submit = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
          if (submit && !submit.disabled) {
            submit.click();
            return;
          }
          this.buyBox?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        }

        update(variant) {
          if (!variant) return;
          if (this.price) this.price.textContent = `${formatMoney(variant.price)} ${this.dataset.currency}`;
          if (this.variantName) this.variantName.textContent = variant.title;

          const src = variant.featured_image?.src;
          if (this.image && src) {
            const url = new URL(src, window.location.href);
            url.searchParams.set('width', '120');
            this.image.removeAttribute('srcset');
            this.image.src = url.href;
          }
        }
      }
    );
  }
  /*
    سعر Kaching: يقرا سعر أول باقة من بلوك Kaching (يتحمّل بالـ JS وممكن يتبدل ويا اختبارات A/B)،
    ويكتبه بالسعر الحالي، ويحسب التوفير من السعر المشطوب. MutationObserver يرجّع السعر لما
    product-info.js مال Dawn يعيد رسم السعر (تبديل التشطيب)، أو لما Kaching يتغيّر.
  */
  const kachingSource = document.querySelector('[data-kaching-source]');
  if (kachingSource) {
    const productId = kachingSource.dataset.productId;
    const reveal = () => {
      document.querySelectorAll('.is-price-pending').forEach((el) => el.classList.remove('is-price-pending'));
    };
    // إذا Kaching ما حمّل، يبين سعر شوبيفاي
    setTimeout(reveal, 4000);

    const kachingCents = () => {
      const bar = document.querySelector('kaching-bundles-block .kaching-bundles__bar');
      const text = bar?.querySelector('.kaching-bundles__bar-price')?.textContent || '';
      // العملة بدون كسور: "20.000 د.ع" أو "20,000 د.ع" ← 20000
      const digits = text.replace(/[^0-9]/g, '');
      return digits ? Number(digits) * 100 : null;
    };

    const setText = (el, text) => {
      if (el && el.textContent !== text) el.textContent = text;
    };
    const setShown = (el, shown) => {
      const display = shown ? '' : 'none';
      if (el && el.style.display !== display) el.style.display = display;
    };

    const apply = () => {
      const cents = kachingCents();
      if (cents === null) return;
      document.querySelectorAll('[data-live-price]').forEach((box) => {
        if (box.dataset.productId && box.dataset.productId !== productId) return;
        const currency = box.dataset.currency;
        setText(box.querySelector('[data-live-now]'), `${formatMoney(cents)} ${currency}`);
        const was = box.querySelector('[data-live-was]');
        const compare = Number(was?.dataset.compareCents || 0);
        const hasSaving = compare > cents;
        setShown(was, hasSaving);
        const save = box.querySelector('[data-live-save]');
        setShown(save, hasSaving);
        if (save && hasSaving) setText(save, `${save.dataset.label} ${formatMoney(compare - cents)} ${currency}`);
      });
      reveal();
    };

    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true, characterData: true });
    apply();
  }
})();
